import { useApi } from '@/api';
import { KpiCard, KpiSkeleton } from '@/components';
import { tokensMapping } from '@/utils/tokens';
import { Flex } from '@blockanalitica/ui';

export default function OverviewKpis() {
  const [data, error] = useApi({
    url: `/liquidations/overview/`
  });

  if (error) {
    throw error;
  }

  if (data) {
    return (
      <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
        <KpiCard title="Total Liquidations" data={data} field="auctions" />
        <KpiCard
          title="Total Collateral Auctioned"
          data={data}
          field="collateral_auctioned_usd"
          options={{
            valueOptions: { currencyValueOptions: { currency: 'USD' } },
            valueTrendOptions: {
              currencyValueOptions: { currency: 'USD' }
            }
          }}
        />
        <KpiCard
          title="Total Debt Repaid"
          variant="dai"
          data={data}
          field="debt_repaid"
          options={{
            valueOptions: {
              currencyValueOptions: {
                currency: tokensMapping('DAI'),
                iconSize: '3'
              }
            }
          }}
        />
      </Flex>
    );
  }
  return (
    <Flex gap={['m', 's']} flexDirection={['column', 'row']}>
      <KpiSkeleton />
      <KpiSkeleton />
      <KpiSkeleton />
    </Flex>
  );
}
